<template>
  <v-app id="ReportGeneratorRouter">
    <v-main>
      <v-container class="mb-0 pb-0" fluid>
        <ReportGeneratorRouterView/>
      </v-container>
    </v-main>

    <v-footer class="pa-3" height="80">
      <v-layout column>

        <v-layout justify-center>
          {{ $t('footerText')}} &nbsp;
          <a href="mailto:EPSupport@myriadgenetics.eu?Subject=Endopredict"> EPSupport@myriadgenetics.eu </a>
        </v-layout>

        <v-layout justify-center wrap>
          <v-btn v-for="link in links" text rounded :href="link.url" v-bind:key="link.id">{{ link.name }}</v-btn>
        </v-layout>

        <div class="version-label">V&nbsp;1.0.15</div>
      </v-layout>
    </v-footer>

  </v-app>
</template>

<script>
const axios = require('axios');
import ReportGeneratorRouterView from '@/components/ReportGeneratorRouter';

export default {
    name: 'ReportGeneratorRouter',
    components: { ReportGeneratorRouterView },
    data: () => ({
        links: {
            terms: {name: "Terms of Use", id: "terms", url: "https://endopredict.eu/terms-of-use"},
            edps: {name: "European Data Privacy Statement", id: "edps", url: "https://myriadgenetics.eu/data-protection-and-privacy-statement/"},
            npp: {name: "Notice of Privacy Practices", id: "npp", url: "https://myriad-oncology.com/notice-of-privacy-practices/"},
            privacy_notice: {name: "Privacy Policy", id: "privacy_notice", url: "https://endopredict.eu/privacy_policy"},
        }
    }),
    mounted:  function() {
      var vm = this;
      var i;
        for (i in vm.links) {
            axios
                .get('https://services.myriad.com/notices/notices', {params: {notice_id: vm.links[i].id}})
                .then(function (response) {
                    vm.links[response.data.notice_id].url = response.data.download_link;
                })
        }
    }
}
</script>

<style scoped>
  .version-label {
    font-size: small;
    color: transparent;
    position: absolute;
  }
  .version-label:hover {
    color: black;
  }
</style>
